import { render, staticRenderFns } from "./privacy2.vue?vue&type=template&id=82fc7008&scoped=true"
import script from "./privacy2.vue?vue&type=script&lang=js"
export * from "./privacy2.vue?vue&type=script&lang=js"
import style0 from "./privacy2.vue?vue&type=style&index=0&id=82fc7008&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82fc7008",
  null
  
)

export default component.exports